import rest from "@data/restWrapper";
import useStore from "@data/state/zustand";

export const reloadBMSData = async () => {
    const BMSNodes = await rest ("/BMSNode", "GET")
    // const BMSUUids = ['66dab549-7ed5-4ddc-be98-46346b21b959',"9je19352-9e10-4691-b62b-9fe3742e8c6d" ]
    // let BMSUUids = ['66dab549-7ed5-4ddc-be98-46346b21b959']
    let BMSUUids = []
    if(BMSNodes?.length > 0){
        for (const element of BMSNodes) {
            BMSUUids.push(element.BMSNodeUUID)
        }
    }
    const BMS:any = {};
    for (const BMSUuid of BMSUUids) {
        if (!BMS[BMSUuid]) {
            BMS[BMSUuid] = {};
        }
        const _devices = await rest(`/api/BMS/v1/getAllDevices/${BMSUuid}`);
        const _scenes = await rest(`/api/BMS/v1/getAllScenes/${BMSUuid}`);
        const _groups = await rest(`/api/BMS/v1/getAllGroups/${BMSUuid}`);
        const _groupItems = await rest(`/api/BMS/v1/getAllGroupItems/${BMSUuid}`);
        BMS[BMSUuid] = {
            Device: _devices,
            Group: _groups,
            GroupItem: _groupItems,
            Scene: _scenes,
        };
    }
    useStore.getState().setNestedProperty(['BMS'], BMS);
    useStore.getState().setNestedProperty(['BMSUuid'], BMSUUids);
};


export const syncBMSNodeData = async () => {
    const BMSNodes = await rest ("/BMSNode", "GET")
    let BMSUUids = []
    if(BMSNodes?.length > 0){
        for (const element of BMSNodes) {
            BMSUUids.push(element.BMSNodeUUID)
        }
    }
    for (const BMSUuid of BMSUUids) {
        await rest(`/api/BMS/v1/getBMSNodeData/${BMSUuid}`)

    }
};

